import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { User } from "vue-simple-acl";
import type { Acl } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION } from "~/modules/globalDeviceConfiguration/constants";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION,
    component: () =>
      import("~/modules/globalDeviceConfiguration/views/GlobalDeviceConfigurationPage.vue"),
    meta: {
      breadcrumb: BREADCRUMBS.GLOBAL_DEVICE_CONFIGURATION,
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
    },
  },
];

export default routes;
